import { render } from "./RemoveMenuCategory.vue?vue&type=template&id=8d260ff6&scoped=true"
import script from "./RemoveMenuCategory.vue?vue&type=script&lang=js"
export * from "./RemoveMenuCategory.vue?vue&type=script&lang=js"

import "./RemoveMenuCategory.vue?vue&type=style&index=0&id=8d260ff6&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d260ff6"]])

export default __exports__